import React from 'react';
import ApplicationAllDetails from './applicationAllDetails';
import ApplicationAnalysis from './applicationAnalysis';
import { INewAnalysisResult } from '../../Models/applicationModels';
import { IEscalation } from "../../Models/applicationModels";
import EscalationTable from "../../Components/EscaltionTable/EscalationTable";
import { getApplicationListRespModel } from '../../Models/tableDetailsModel';

interface TabContentProps {
    currentTab: number;
    detailsPageApplicationDetails: getApplicationListRespModel;
    setNewAnalysisResult: React.Dispatch<React.SetStateAction<INewAnalysisResult>>;
    newAnalysisResult: INewAnalysisResult;
    escalationInfo: IEscalation[] | null
}

const InsightPageSwitcher: React.FC<TabContentProps> = (props) => {
    const {
        currentTab,
        detailsPageApplicationDetails,
        setNewAnalysisResult,
        newAnalysisResult,
        escalationInfo } = props;

    switch (currentTab) {
        case 0:
            return <ApplicationAllDetails appDetails={detailsPageApplicationDetails} />;
        case 1:
            return (
                <ApplicationAnalysis
                    setNewAnalysisResult={setNewAnalysisResult}
                    newAnalysisResult={newAnalysisResult}
                />
            );
        case 2:
            return <EscalationTable escalations={escalationInfo} record={detailsPageApplicationDetails} />
        default:
            return null;
    }
};

export default InsightPageSwitcher;